<template>

  <div class="ibox">
    <div class="ibox-title pt-3">
      <h5><strong>Usuários desta empresa</strong></h5>
    </div>

    <div class="ibox-content">
      <div class="row" v-if="$withPolicy()">
        <div class="col-md-12">
          <button
              @click="showModal=true"
              class="btn btn-primary btn-lg"
          >
            Adicionar usuário
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <table class="table table-borderless table-border">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Tipo de perfil</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ (user.accountUser || {}).role | t }}</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>

        </div>
      </div>

    </div>

    <Modal v-model="showModal">
      <span slot="header">
        Vincular empresa ao usuário
      </span>

      <Select2 v-model="userIds" :options="optionsUsers"/>

      <template slot="footer">
        <button @click="showModal=false" class="btn btn-outline btn-lg">Cancelar</button>
        <button @click="updateUsers" class="btn btn-primary btn-lg">Salvar</button>
      </template>

    </Modal>

  </div>

</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import Modal from '@/components/shares/specialTag/Modal'
  import GetAccount from '@/mixins/GetAccount.vue';

  export default {
    components: { Modal, Pagination, Select2 },
    computed: {
      users() {
        return this.getModels || []
      }
    },
    created() {
      this.query.cnpj = this.company.cnpj
      this.includes.push('account_user')

      this.find(this.createOptionsUsers)
    },
    data() {
      return {
        nameModel: 'Users',
        optionsUsers: [],
        showModal: false,
        userIds: null
      }
    },
    methods: {
      createOptionsUsers() {
        const params = {
          fields: ['id', 'name', 'email'],
          meta: false,
          query: { role: 'member' }
        }

        this.axios.get('users',  { params: params })
          .then(response => response.data)
          .then(users => this.$parse.toCamelcase(users))
          .then(users => this.optionsUsers = users.map(u => ({
            label: u.name.toUpperCase() + ' - ' + u.email,
            value: parseInt(u.id)
          })))
      },
      find(callback) {
        this.asyncTemplateSelect({
          after: () => {
            this.userIds = this.users.map(u => u.id)
            typeof callback === 'function' && callback()
          }
        })
      },
      updateUsers() {
        this.axios.put(`companies/${this.company.id}`, { user_ids: this.userIds })
        .then(() => this.find())
        .then(() => this.showModal = false)
        .catch(e => this.$notify.addError(e))
      },
    },
    mixins: [ModelMapper, GetAccount],
    name: 'CardUser',
    props: {
      company: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>
